import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';

const updateTour = async ({ finalFormValidation, resourcePersonnelData, state, userId, updateState, editTour, Toast, refreshPage }) => {
  if (!finalFormValidation()) {
    return null;
  }
  const resourceId = state.resource.id;
  const personnelData = await resourcePersonnelData;
  const { unionId, contractId, rulesGRP, hourlyActivityFlag, rate, jobSalaryId } = personnelData;
  const { itemDetails } = state;
  const { tourId, timeZoneId, mealStartTime, tourComment, myTourComment, notificationComment, showBusy } = itemDetails;
  const parameters = {
    tourId,
    resourceId,
    // inputing time as a string in this format into SP eliminates the need to adjust timeZoneOffset again
    dateTimeStartActual: moment(itemDetails.tourStartTime).format('YYYY-MM-DD HH:mm:ss'),
    dateTimeEndActual: moment(itemDetails.tourEndTime).format('YYYY-MM-DD HH:mm:ss'),
    unionId,
    contractId,
    contractRulesGroupId: rulesGRP,
    salaryLevelId: 0,
    timeZoneId,
    userId,
    comment: tourComment || ' ', // tourComment,
    comment15: myTourComment || ' ', // myTourComment,
    notification: notificationComment || ' ', // notificationComment,
    showBusy: showBusy || false,
    postTK: false,
    TKComment: null,
    baseRateId: hourlyActivityFlag === 1 ? 3 : 0,
    baseOverrideType: hourlyActivityFlag === 1 ? 'EXP' : 'NON',
    baseOverride: hourlyActivityFlag === 1 ? rate : 0,
    jobSalaryId
  };

    // store tour parameters for optimistic re-ender
    itemDetails.tourParams = parameters;
    await updateState({itemDetails});
    // update tour
    const { resource } = state;
    const { tourStartTime } = state.itemDetails;
    const date = moment(tourStartTime).format('M/D/YYYY (ddd)');
    let notification = {type: 'success', message: 'Tour Updated', description: `For ${resource.name} on ${date}`};
    try {
      await editTour(parameters);
    }
    catch(error) {
      if (!_.isEmpty(error)) {
        updateState({
          crudError: {
            failedAction: 'editTour',
            message: parseError(error)
          }
        });
        console.log(error);
        notification = {
            type: 'error',
            message: "Updating Tour Failed",
            description: `For [${resource.name} on ${date}]: ${parseError(error)}`
          };
        }
    }
    Toast(notification);
    refreshPage();
}

export default updateTour;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/tour/updateTour.js